import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
import { TableLimit } from '@/datamodel/types'
import { DeskMoreInfoModel } from '@/datamodel/urlparams/DeskMoreInfoModel'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import RoadMapView from '@/components/roadmap/index.vue'
import { useI18n } from 'vue-i18n'
import { MemberLimit, Table } from 'vue'
import { store } from '@/store'
import { UserMutation } from '@/store/module/user'
import { DeskMutation } from '@/store/module/desk'
import {
    formatGoodRoadName,
    getTableGoodRoads,
    isGoodRoadGameType
} from '@/components/desk/good-road/utils'

@Options({
    components: {
        RoadMapView
    }
})
export class LobyListItemMixin extends Vue {
    iN = useI18n().t
    //#region  Prop
    // display 1 this diplay the normal list
    // diplay value > 1 this will display picrure view
    @Prop({ default: 1 })
    display!: number

    @Prop({ default: -1 })
    selectedIndex!: number
    @Prop({ default: -1 })
    itemIndex!: number
    @Prop({ default: undefined })
    deskData!: Table

    //#endregion

    readyToRenderMap = false
    deskResult = ''

    currentTime = -1
    deskTimer: number | boolean = false
    $emit!: Vue['emit']

    //#region Vuex Action
    @Action('getDeskOtherInfo') getDeskOtherInfo!: (
        model: DeskMoreInfoModel
    ) => Promise<ResponseData>

    @Action('destroySession') destroySession!: () => void
    @Action('setDeskLimit') setDeskLimit!: (limit: TableLimit) => void
    @Action('setDeskNotice') setDeskNotice!: (notice: string) => void
    @Action('setChipsValues') setChipsValues!: (
        chipvalues: Array<number>
    ) => void
    @Action('setCurrentDesk') setCurrentDesk!: (
        model: DeskData | undefined
    ) => void
    @Action('setMultiDeskTables')
    setMultiDeskTables!: (tables: Array<number>) => void

    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    //#endregion

    //#region Vuex Getter
    @Getter('userLimits') userLimits!: Array<MemberLimit>
    @Getter('desks') desks!: Array<DeskData>
    //#endregion
    //#region Vue Methods
    mounted(): void {
        // if (this.display === 1) {
        // this.drawMap()
        this.readyToRenderMap = true
        // }
    }

    beforeUnmount(): void {
        this.StopDeskTimer()
    }

    //#endregion

    //#region Helpler Method
    enterDesk(limit: MemberLimit): void {
        store.commit(DeskMutation.SET_DESK_LIMIT, limit)
        console.log('oppps')
        this.$emit('enter-table', this.deskData)
    }

    StopDeskTimer(): void {
        if (typeof this.deskTimer === 'number') {
            clearInterval(this.deskTimer)
            this.deskTimer = false
            this.currentTime = -1
        }
    }
    //#endregion

    //#region Computed Properties
    get title(): string {
        if (!this.deskData) return ''
        if (this.deskData.gameTypeNo === 'G002') {
            return `百家乐 ${this.deskData.id} 号桌`
        } else if (this.deskData.gameTypeNo === 'G003') {
            return `龙虎 ${this.deskData.id} 号桌`
        }

        return ''
    }

    get gameType(): string {
        if (this.deskData) return this.deskData.gameTypeNo

        return ''
    }

    get timerClass(): string {
        if (!this.deskData) return ''

        if (this.currentTime > 20) {
            return 'green'
        } else if (this.currentTime <= 20 && this.currentTime > 10) {
            return 'orange'
        } else {
            return 'red'
        }
    }

    get xueAndJu(): string {
        if (!this.deskData) return '局数 0-0'

        return `局数 ${this.deskData.expand.shoeNo} - ${this.deskData.expand.juNo}`
    }

    get goodRoadName(): string {
        if (!this.deskData || !isGoodRoadGameType(this.deskData.gameTypeNo)) {
            return ''
        }

        const goodRoads = getTableGoodRoads(this.deskData)
        if (!goodRoads.length) return ''

        return formatGoodRoadName(goodRoads[0].id, this.deskData.gameTypeNo)
    }
    //#endregion

    //#region Watchers
    @Watch('deskData', { immediate: true })
    OnDataChange(value: Table): void {
        if (value) {
            this.deskResult = value.expand.resultList.join('#') || ''

            if (
                value.expand.daoJiShiBetTime > 0 &&
                typeof this.deskTimer !== 'number'
            ) {
                this.currentTime = value.expand.daoJiShiBetTime
                this.deskTimer = setInterval(() => {
                    if (this.currentTime > 0) {
                        this.currentTime -= 1
                    } else {
                        this.StopDeskTimer()
                    }
                }, 1000)
            } else if (
                value.expand.daoJiShiBetTime === -1 &&
                typeof this.deskTimer === 'number'
            ) {
                this.StopDeskTimer()
                this.currentTime -= 1
            }
        }
    }
    //#endregion
}
